import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import { sideViewState } from '@chainlit/react-client';

import Chat from '@/components/chat';

export default function Home() {
  const setSideView = useSetRecoilState(sideViewState);

  useEffect(() => {
    setSideView(undefined);
  }, [setSideView]);

  return <Chat />;
}
